export const backend_server = {
	"server": 		"https://pemt-test-api.mondas.io",
	"websocket": 	"wss://pemt-test-api.mondas.io",
	"sync_active": 	true
}

export default backend_server